import { RotateCw } from 'lucide-react'
import { cn } from '@utils'
import { PORTAL_PAGES } from '@/constants'
import { pageFromPath } from '../utils/portalNav'
import OmpSkeletonCard from './OmpSkeletonCard'
import OmpDetailSkeleton from './OmpDetailSkeleton'
import OmpDetailHeader from './OmpDetailHeader'

const ListHeader = ({ tabs }: { tabs?: string[] }) => (
  <>
    <div className="flex items-center justify-between gap-3">
      <h2 className="omp-page-title min-w-0">
        <span className="skeleton omp-skel-line omp-skel-line-lg omp-skel-w-35 block" />
      </h2>
      <button type="button" className="omp-refresh" tabIndex={-1} aria-hidden="true">
        <RotateCw size={16} aria-hidden="true" />
        <span>Refresh</span>
      </button>
    </div>
    {tabs && (
      <div className="omp-tabs" aria-hidden="true">
        {tabs.map((label, i) => (
          <button
            key={label}
            type="button"
            tabIndex={-1}
            className={cn('omp-tab', 'no-transform', i === 0 && 'omp-tab-active')}>
            {label}
          </button>
        ))}
      </div>
    )}
  </>
)

const OmpRouteSkeleton = ({ pathname }: { pathname: string }) => {
  switch (pageFromPath(pathname)) {
    case PORTAL_PAGES.Subscriptions:
      return (
        <div className="omp-page omp-subscriptions">
          <div className="omp-list-section">
            <ListHeader tabs={['Active', 'Inactive']} />
            <OmpSkeletonCard count={3} variant="subscription" />
          </div>
        </div>
      )
    case PORTAL_PAGES.Orders:
      return (
        <div className="omp-page omp-orders">
          <div className="omp-list-section">
            <ListHeader />
            <OmpSkeletonCard count={3} variant="order" />
          </div>
        </div>
      )
    case PORTAL_PAGES.SubscriptionDetails:
      return (
        <div className="omp-page omp-subscription-details">
          <OmpDetailHeader to="/portal/subscriptions" title="Subscription Details" />
          <OmpDetailSkeleton />
        </div>
      )
    case PORTAL_PAGES.OrderDetails:
      return (
        <div className="omp-page omp-order-details">
          <OmpDetailHeader to="/portal/orders" title="Order Details" />
          <OmpDetailSkeleton />
        </div>
      )
    default:
      return <OmpSkeletonCard count={2} variant="rows" />
  }
}

export default OmpRouteSkeleton
